"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _material = require("@mui/material");

var _style = _interopRequireDefault(require("./style"));

var _index = _interopRequireDefault(require("../FotoConEliminar/index"));

var _uploadToS = require("../../utils/uploadToS3");

var _uploadBro = _interopRequireDefault(require("../../images/upload-bro.svg"));

var _react2 = require("@emotion/react");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

class FormFotoPerfil extends _react.default.Component {
  constructor(props) {
    super(props);
    this.onAddFoto = this.onAddFoto.bind(this);
    this.onUploadPreviewFoto = this.onUploadPreviewFoto.bind(this);
    this.sendFiles = this.sendFiles.bind(this);
    this.onDelete = this.onDelete.bind(this);
    this.state = {
      foto: this.props.foto
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.foto != this.props.foto) {
      this.setState({
        foto: this.props.foto
      });
    }
  }

  onAddFoto() {
    (0, _uploadToS.uploadFileToS3)(this.uploadInput, this.props.referencia, this.props.tipo, this.onUploadPreviewFoto, this.sendFiles, null);
  }

  onUploadPreviewFoto(url, name) {
    this.props.onChange(1, {
      id: null,
      id_album: null,
      nombre: name,
      url
    });
  }

  sendFiles(files) {
    this.props.getFiles(files);
  }

  onDelete(foto) {
    this.props.onChange(2, foto);
  }

  render() {
    const {
      title,
      description
    } = this.props;
    return (0, _react2.jsx)("div", null, (0, _react2.jsx)(_material.Typography, {
      variant: "h6"
    }, title), (0, _react2.jsx)(_material.Typography, {
      variant: "body1"
    }, description), Object.keys(this.state.foto).length ? (0, _react2.jsx)("div", {
      css: _style.default.fotoPerfilContainer
    }, (0, _react2.jsx)(_index.default, {
      cargando: !this.state.foto.id,
      foto: this.state.foto,
      onDelete: this.onDelete
    })) : (0, _react2.jsx)("div", {
      css: _style.default.emptyStateContainer
    }, (0, _react2.jsx)("img", {
      src: _uploadBro.default,
      css: _style.default.emptyState
    })), (0, _react2.jsx)("input", {
      accept: "image/*",
      css: _style.default.inputFile,
      id: "button-file-perfil",
      type: "file",
      ref: ref => {
        this.uploadInput = ref;
      },
      onChange: this.onAddFoto
    }), (0, _react2.jsx)("div", {
      css: _style.default.containerAgregarFotos
    }, (0, _react2.jsx)("label", {
      htmlFor: "button-file-perfil"
    }, (0, _react2.jsx)(_material.Button, {
      color: "primary",
      component: "span",
      variant: "outlined"
    }, "Cargar foto"))), (0, _react2.jsx)("hr", null));
  }

}

var _default = FormFotoPerfil;
exports.default = _default;